import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthActions, useAuthModal } from 'authOld/hooks';
import { IForgotPasswordForm } from 'authOld/types';
import { HeaderModalOptions } from 'coreOld/constants';
import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useNotification } from 'coreOld/hooks/useNotification';

import ForgotPasswordFormView from './ForgotPasswordFormView';

const ForgotPasswordForm = () => {
  const { t } = useTranslation();

  const [isSubmitted, setIsSubmitted] = useState(false);

  const {
    openedAuthModal,
    openAuthModal,
    parentAuthModal,
    closeAuthModal,
    setOpenedAsParentAuthModal,
  } = useAuthModal();

  const { forgotPassword } = useAuthActions();

  const { clearNotification, showNotification } = useNotification();

  useEffect(() => {
    setOpenedAsParentAuthModal(HeaderModalOptions.FORGOT_PASSWORD);

    if (openedAuthModal === HeaderModalOptions.FORGOT_PASSWORD) {
      setIsSubmitted(false);
    }
  }, [openedAuthModal]);

  const onSubmit = () => async (data: IForgotPasswordForm) => {
    await forgotPassword(data);

    showNotification({
      message: t('messageForgotPasswordInfo'),
      type: ApiStatuses.INFO,
      position: NotificationPosition.MODAL,
    });

    setIsSubmitted(true);
  };

  const handleGoBack = () => {
    if (isSubmitted) {
      clearNotification();
      setIsSubmitted(false);

      return;
    }

    openAuthModal(parentAuthModal);
  };

  return (
    <ForgotPasswordFormView
      isOpen={openedAuthModal === HeaderModalOptions.FORGOT_PASSWORD}
      onClose={closeAuthModal}
      onSubmit={onSubmit}
      isSubmitted={isSubmitted}
      goBack={handleGoBack}
    />
  );
};

export default ForgotPasswordForm;
